import { makeStyles } from '@fluentui/react-components';

export const useTreeStyles = makeStyles({
  rootList: {
    '& .tree-item-layout': {
      paddingLeft: '0px',
    },
  },
});
